<ion-header>
  <app-header></app-header>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="calls-wrap page-width-and-shadow">
    <ion-skeleton-text *ngIf="!url" style="width:100%;height:2.5rem;margin-bottom: 1rem;" animated></ion-skeleton-text>
    <ion-skeleton-text *ngIf="!url" style="width:60%;height:2.5rem;margin-bottom: 1rem;" animated></ion-skeleton-text>
    <ion-skeleton-text *ngIf="!url" style="width:75%;height:2.5rem;margin-bottom: 1rem;" animated></ion-skeleton-text>

    <iframe *ngIf="!!url" [src]="url | safeUrl" allow="microphone *; clipboard-read *; clipboard-write *"></iframe>
  </div>
</ion-content>
